import { useState, createContext } from "react";
import ReactDOM from "react-dom/client";

const NavContext = createContext()

export default NavContext